<template>
    <div class="content-title">{{ title }}</div>
</template>

<script lang="ts">
export default {
    props: {
        title: String
    }
};
</script>

<style lang="scss" scoped>
.content-title {
    line-height: 56px;
    font-family: PingFangSC-Semibold;
    font-size: 22px;
    color: #333333;
    letter-spacing: 0;
    font-weight: 600;
    position: relative;
    padding-left: 8px;
    border-bottom: 1px solid #a6bedf;

    &::before {
        content: '';
        display: inline-block;
        width: 3px;
        height: 20px;
        background-color: #2e6ddd;
        position: absolute;
        top: 20px;
        left: 0;
    }
}
</style>
